import * as React from 'react';
import { Field } from 'redux-form';
import { Col, Row } from 'react-bootstrap';
import { isRequired } from '../../../../../../util/validators';
import { II18nMessages } from '../../../../../../services/branding/models';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { IChannel } from '../../../../../../data/api/models';

interface ITripDetailsForm {
  i18n: II18nMessages;
  channel: IChannel;
}

class CruiseQuestion extends React.Component<ITripDetailsForm> {
  public renderQuestions = () => {
    return (
      <div className="cruise">
        <Col xs={6} className="cruise cruise-btn--padding">
          <Field
            name="options.cruise_cover"
            type="radio"
            id="cruise-cover-yes"
            format={null}
            value={true}
            complexValue={true}
            className="answer"
            component={FieldFormControl}
            validate={[isRequired]}
          >
            <div className="cruise-btn answer--yes">Yes</div>
          </Field>
        </Col>
        <Col xs={6} className="cruise cruise-btn--padding">
          <Field
            name="options.cruise_cover"
            type="radio"
            id="cruise-cover-no"
            format={null}
            value={false}
            complexValue={true}
            className="answer"
            component={FieldFormControl}
            validate={[isRequired]}
          >
            <div className="cruise-btn answer--no">No</div>
          </Field>
        </Col>
      </div>
    );
  }

  public render() {
    const { i18n } = this.props;
    return (
      <Row>
        <Col sm={3} className="cruise-title">
          {i18n.quote.tripDetails.cruise}
        </Col>
        <Col sm={4}>{this.renderQuestions()}</Col>
      </Row>
    );
  }
}

export default CruiseQuestion;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/CruiseQuestion/CruiseQuestion.tsx